var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-main',[_c('v-container',[_c('component-title',{attrs:{"title":"header_my_account"}}),_c('user-profile-component')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }